import ApolloClientOptionsContext from 'contexts/apollo-client-options';
import {
  ApolloClientOptions,
  useApollo,
  WEB_CLIENT_NAME,
} from 'lib/apollo-client';
import { ApolloProvider } from '@apollo/client';
import { ReactNode, useMemo, useState } from 'react';

const initialClientOptions: ApolloClientOptions = {
  clientName: WEB_CLIENT_NAME,
};

const ApolloClientProvider = ({ children }: { children: ReactNode }) => {
  const [clientOptions, setClientOptions] = useState<ApolloClientOptions>(
    initialClientOptions
  );

  const client = useApollo(clientOptions);

  const value = useMemo(() => ({ setClientOptions }), []);

  return (
    <ApolloClientOptionsContext.Provider value={value}>
      <ApolloProvider client={client}>{children}</ApolloProvider>
    </ApolloClientOptionsContext.Provider>
  );
};

export default ApolloClientProvider;
